import { match } from "ts-pattern";

import { AcademiaLoader } from "~/components/AcademiaLoader";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "~/components/ui/toast";
import { useToast } from "~/components/ui/use-toast";


import { Icon } from "../Icon";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider duration={4000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex items-center gap-1">
              {match(props.variant)
                .with("success", () => (
                  <Icon
                    name="InputRoundedMarkerSuccess"
                    className="mr-2 size-4 text-green-500 shrink-0"
                  />
                ))
                .with("loading", () => (
                  <AcademiaLoader compact label="Procesando" className="mr-2 shrink-0" />
                ))
                .otherwise(() => null)}
              <div className="flex flex-col">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
